<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ovYvLD/image/Cover.jpg?1708094026389" alt="This image is the cover for the book Mrs Brown's Magical Music Box"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mrs Brown's Magical Music Box
      </h1>
      <p class="bookDescription body article font2">
        <p>Mrs Brown has a wonderful box. A wonderful, magical, music box. What is inside? Nobody knows. Come inside and take a peek. You might even need to stop tapping your feet. Learn about rhythm, and musical beats. March to the rhythm, and swing with me. Come in and join the journey, And learn along the way, With Molly and her friends, Let’s get on our way!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alysha Griffiths
      </h2>
      
      <p class="authorDescription body article">Alysha Griffiths is a wife and mother to her beautiful daughter. She is a lifelong learner and passionate teacher who owns and runs her own tutoring centre, and enjoys writing in her free time. In addition to being a qualified teacher, her hidden talent is playing classical guitar and she can also play another five instruments as well. Alysha is based in Australia, she enjoys heading to the beach with her husband, daughter and extended family in her down time and is pretty sure she has visited every playground the country has to offer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f27563f